import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=777bf578"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports